import { render, staticRenderFns } from "./parent-agree.vue?vue&type=template&id=34e28762&"
import script from "./parent-agree.vue?vue&type=script&lang=js&"
export * from "./parent-agree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports